import React from 'react';

const LEVEL1 = [
  { wert: 'student',        label: 'Student' },
  { wert: 'ausbildung',     label: 'In Ausbildung' },
  { wert: 'angestellt',     label: 'Fest angestellt' },
  { wert: 'selbststaendig', label: 'Selbstständig' },
  { wert: 'freelancer',     label: 'Freelancer' },
  { wert: 'arbeitslos',     label: 'Arbeitslos' },
  { wert: 'jobsuchend',     label: 'Auf Jobsuche' },
  { wert: 'pause',          label: 'Berufsrückkehrend' },
];

const BRANCHEN = [
  { wert: 'it',         label: 'IT & Tech' },
  { wert: 'wirtschaft', label: 'Wirtschaft & Finanzen' },
  { wert: 'ingenieur',  label: 'Ingenieurwesen' },
  { wert: 'medizin',    label: 'Medizin & Gesundheit' },
  { wert: 'marketing',  label: 'Marketing & Komm.' },
  { wert: 'design',     label: 'Design & Kreative' },
  { wert: 'recht',      label: 'Recht & Verwaltung' },
  { wert: 'bildung',    label: 'Bildung & Soziales' },
  { wert: 'handwerk',   label: 'Handwerk & Produktion' },
  { wert: 'vertrieb',   label: 'Vertrieb & Handel' },
];

const SUBOPTIONS = {
  student: {
    label: 'Und welches Fach studierst du?',
    optionen: [
      { wert: 'informatik', label: 'Informatik / IT' },
      { wert: 'wirtschaft', label: 'BWL / Wirtschaft' },
      { wert: 'ingenieur',  label: 'Ingenieurwesen' },
      { wert: 'medizin',    label: 'Medizin / Pharma' },
      { wert: 'recht',      label: 'Jura / Politik' },
      { wert: 'soziales',   label: 'Soziales / Päd.' },
      { wert: 'design',     label: 'Design / Medien' },
      { wert: 'natur',      label: 'Naturwiss.' },
      { wert: 'geistes',    label: 'Geisteswiss.' },
      { wert: 'anderes',    label: 'Anderes' },
    ],
  },
  ausbildung: {
    label: 'Und in welchem Bereich lernst du?',
    optionen: [
      { wert: 'kaufmann',   label: 'Kaufmann / -frau' },
      { wert: 'it',         label: 'IT-Berufe' },
      { wert: 'handwerk',   label: 'Handwerk / Technik' },
      { wert: 'gesundheit', label: 'Gesundheit / Pflege' },
      { wert: 'gastro',     label: 'Gastronomie / Hotel' },
      { wert: 'logistik',   label: 'Logistik / Lager' },
      { wert: 'verwaltung', label: 'Büro / Verwaltung' },
      { wert: 'anderes',    label: 'Anderes' },
    ],
  },
  angestellt:     { label: 'Und in welcher Branche arbeitest du?',    optionen: BRANCHEN },
  selbststaendig: { label: 'Und in welchem Bereich bist du tätig?',   optionen: BRANCHEN },
  freelancer:     { label: 'Und in welchem Bereich bist du tätig?',   optionen: BRANCHEN },
  pause:          { label: 'In welchem Bereich warst du tätig?',      optionen: BRANCHEN },
  arbeitslos: {
    label: 'Welche Branche interessiert dich?',
    optionen: [...BRANCHEN, { wert: 'schauen', label: 'Ich schaue mich erstmal nur um' }],
  },
  jobsuchend: {
    label: 'Welche Branche interessiert dich?',
    optionen: [...BRANCHEN, { wert: 'schauen', label: 'Ich schaue mich erstmal nur um' }],
  },
};

export default function StepStatus({ wert, onChange }) {
  const status  = wert?.status  ?? null;
  const branche = wert?.branche ?? null;

  const zeigeUnter = !!status;
  const subConf    = zeigeUnter ? SUBOPTIONS[status] : null;

  function waehleStatus(s) {
    onChange({ status: s, branche: null });
  }

  function waehleBranche(b) {
    onChange({ status, branche: b });
  }

  return (
    <div className="ob-step-enter">
      {/* Section 01 */}
      <div className="ob-section-header">
        <span className="ob-section-num">02</span>
        <span className="ob-section-question">Wo stehst du gerade?</span>
      </div>
      <div className="ob-chips">
        {LEVEL1.map(o => (
          <button
            key={o.wert}
            type="button"
            className={`ob-chip${status === o.wert ? ' ob-chip--aktiv' : ''}`}
            onClick={() => waehleStatus(o.wert)}
          >
            {o.label}
          </button>
        ))}
      </div>

      {/* Section 02 – animates in after status selection */}
      {zeigeUnter && subConf && (
        <div key={status} className="ob-level2">
          <div className="ob-section-header">
            <span className="ob-section-num">03</span>
            <span className="ob-section-question">{subConf.label}</span>
          </div>
          <div className="ob-chips">
            {subConf.optionen.map((b, i) => (
              <button
                key={b.wert}
                type="button"
                className={`ob-chip ob-chip--animate${branche === b.wert ? ' ob-chip--aktiv' : ''}`}
                style={{ animationDelay: `${0.1 + i * 0.05}s` }}
                onClick={() => waehleBranche(b.wert)}
              >
                {b.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
